import { render, staticRenderFns } from "./AdminXeroCallback.vue?vue&type=template&id=3f4d1d6f"
import script from "./AdminXeroCallback.vue?vue&type=script&lang=js"
export * from "./AdminXeroCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports